import React, { useContext } from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import * as Styled from './styled';
import backdropImage from '../../../assets/confluence-activation/info-background.png';
import { ModalState, ActivationInProgressContext } from '../view';
import ActivationInProgressCarousel from '../activation-in-progress-carousel';
import { MODAL_HEIGHT } from './constants';

const ActivationInProgressModal = () => {
	const { modalState } = useContext(ActivationInProgressContext || ModalState.OPEN);
	return (
		<ModalTransition>
			{modalState === ModalState.OPEN && (
				<Modal height={MODAL_HEIGHT} shouldScrollInViewport>
					<Styled.ModalBody>
						<Styled.Backdrop src={backdropImage} alt="Blue backdrop" />
						<ActivationInProgressCarousel />
					</Styled.ModalBody>
				</Modal>
			)}
		</ModalTransition>
	);
};
export default ActivationInProgressModal;
